export default ({ type, content }) => {
  return `<span class="sp-tag sp-bg-${type}">${content}</span>`
}



// WEBPACK FOOTER //
// ./examples/helper/renderStatus.js